
import React from "react";
import { CreditCard, ArrowLeft, Download, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

interface FinanceiroHeaderProps {
  titulo: string;
  subtitulo?: string;
  // Additional props for the FinanceiroGeradorPage
  geradorNome?: string;
  search?: string;
  onSearchChange?: (value: string) => void;
  onExport?: () => void;
  onGoBack?: () => void;
  hasClientes?: boolean;
  showTransacaoButton?: boolean  // Kept for potential future use
}

const FinanceiroHeader: React.FC<FinanceiroHeaderProps> = ({ 
  titulo, 
  subtitulo,
  geradorNome,
  search,
  onSearchChange,
  onExport,
  onGoBack,
  hasClientes,
  showTransacaoButton = false
}) => {
  // If it's the basic header with just title and subtitle
  if (!geradorNome) {
    return (
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        <div className="flex items-center">
          <div className="p-3 mr-3 bg-gradient-to-br from-blue-400 to-blue-500 rounded-lg shadow-sm">
            <CreditCard className="h-8 w-8 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-normal text-gray-700">{titulo}</h1>
            {subtitulo && <p className="text-gray-500">{subtitulo}</p>}
          </div>
        </div>
      </div>
    );
  }

  // Extended header for the gerador page
  return (
    <div className="flex flex-col space-y-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-2 gap-4">
        <div className="flex items-center">
          {onGoBack && (
            <Button 
              variant="ghost" 
              size="icon" 
              className="mr-2 text-gray-500 hover:text-gray-700" 
              onClick={onGoBack}
              aria-label="Voltar"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
          )}
          <div className="p-3 mr-3 bg-gradient-to-br from-blue-400 to-blue-500 rounded-lg shadow-sm">
            <CreditCard className="h-8 w-8 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-normal text-gray-700">{titulo}</h1>
            <p className="text-gray-500">{geradorNome}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 w-full md:w-auto">
          {onSearchChange && (
            <div className="relative w-full md:w-auto">
              <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-400" />
              <Input
                type="search"
                placeholder="Buscar cliente..."
                className="pl-8 w-full md:w-[250px] border-gray-200 focus:border-blue-300 focus:ring focus:ring-blue-100 rounded-lg"
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </div>
          )}
          {onExport && hasClientes && (
            <Button 
              variant="outline" 
              onClick={onExport}
              size="sm"
              className="whitespace-nowrap border-gray-200 hover:bg-gray-50 text-gray-600 rounded-lg"
            >
              <Download className="h-4 w-4 mr-2 text-blue-500" />
              Exportar
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FinanceiroHeader;
